<template>
  <div class="popup-box popup-set">
    <div class="setting-wrap bg-color setting-index popup">
      <button class="icon-close" @click="hideProfilePopup" />
      <div class="popup-top">
        <a class="back"><i class="icon-arrow-left-lg" /></a>
        <h2 class="tx-center popup-tit">
          {{ $t('설정') }}
        </h2>
      </div>
      <!-- 썸네일 -->
      <div class="tx-center user-info-top">
        <div
          class="profile-photo"
          :style="{
            backgroundImage: `url(${profileImage.url})`,
          }"
          @click="changeViewType('image')"
        >
          <button><i class="icon-photo" /></button>
        </div>
        <div class="name-wrap">
          <div v-if="isEditModeOn" class="nickname-edit">
            <input v-model="newNickname" type="text" @input="hanldeInputChange">
            <button @click="updateNickname">
              {{ $t('저장') }}
            </button>
          </div>
          <div v-else class="nickname">
            {{ userNickName }}<button class="icon-edit" @click="openNicknameEdit()" />
            <CoachMark
              v-if="showProfileNicknameCoach"
              direction="below"
              align="center"
              :tail-offset="{x:4}"
              :offset="{y:-5}"
              :text="$t('닉네임을변경해보세요')"
              @close="dismissNicknameCoach"
            />
          </div>
          <div class="desc">
            {{ $t('사이트안에서사용할닉네임을만들어보세요직접입력가능') }}
          </div>
          <div v-if="isWatvUser" class="desc">
            {{ $t('닉네임은watv와연동되지않습니다') }}
          </div>
          <!-- <div class="score">375<span>점</span></div> -->
        </div>
      </div>

      <!-- <div class="activity">
        <div class="item">
          <i class="icon-checklist"></i>
          <div class="txt">체크리스트 <b>35</b></div>
        </div>
        <div class="item">
          <i class="icon-reple"></i>
          <div class="txt">댓글 <b>35</b></div>
        </div>
        <div class="item">
          <i class="icon-post"></i>
          <div class="txt">게시물 <b>35</b></div>
        </div>
      </div> -->

      <!--설정 목록-->
      <ul class="set-item-list">
        <!--계정-->
        <li class="item">
          <div class="row-text">
            <div class="item-left"><div class="item-tit">{{ $t('연동된계정') }}</div></div>
            <div class="item-right sns-group">
              <span
                class="sns-apple"
                :class="{
                  off: !integratedProviders?.includes('apple'),
                }">
                <i class="icon-apple" />
                <em v-if="recentlyLoginSns === 'apple'" class="recent">{{ $t('최근로그인') }}</em>
              </span>
              <span
                class="sns-kakao"
                :class="{
                  off: !integratedProviders?.includes('kakao'),
                }"
              ><i class="icon-kakao" /><em v-if="recentlyLoginSns === 'kakao'" class="recent">{{ $t('최근로그인') }}</em></span>
              <span
                class="sns-google"
                :class="{
                  off: !integratedProviders?.includes('google'),
                }"
              ><i class="icon-google" /><em v-if="recentlyLoginSns === 'google'" class="recent">{{ $t('최근로그인') }}</em></span>
            </div>
          </div>
          <!--인증여부-->
          <div class="row-text account" @click="isWatvUser ? null : changeViewType('integration')">
            <a class="item-left">{{ $t('하나님의교회성도인증하기') }} <i v-if="!isWatvUser" class="icon-arrow-right" /></a>
            <CoachMark
              v-if="showSaintCoach"
              direction="below"
              align="left"
              :offset="{x:-18}"
              :tail-offset="{x: 100}"
              :text="$t('하나님의교회성도라면인증해주세요')"
              @close="dismissSaintCoach"
            />
            <div v-if="isWatvUser" class="item-right verified">{{ $t('인증됨') }}</div>
            <div v-else class="item-right">{{ $t('인증') }}</div>
          </div>
        </li>
        <!--내가쓴글-->
        <li class="item">
          <a class="row-text" href="/mypage/post">
            <div class="item-tit">{{ $t('내가쓴글') }}</div>
            <div class="item-right"><span class="num">{{ myPostCountTotal }}</span><i class="ico ico-arrow-right"></i></div>
          </a>
        </li>
        <!--로그아웃-->
        <li class="item">
          <a class="row-text" @click="logout">
            <div class="item-left">
              <div class="item-tit">{{ $t('로그아웃') }}</div>
              <div v-if="isMobile" class="desc">{{ $t('보안을위해{}일후에자동로그아웃됩니다').replace('{}', '30') }}</div>
            </div>
            <div class="item-right"><i class="ico ico-arrow-right"></i></div>
          </a>
        </li>
      </ul>
      <div>
        <a class="withdraw" @click="changeViewType('withdraw')">{{ $t('탈퇴하기') }} <i class="icon-arrow-right" /></a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { STORAGE_RECENTLY_LOGIN_SNS_KEY } from '~/constants/storageKeys'

const { userNickName, logout, changeMyNickname, profileImage, isWatvUser } = useAuth()
const { hideProfilePopup, changeViewType, fetchMyIntegratedSnsProviders } = useProfile()
const { showProfileNicknameCoach, showSaintCoach, dismissNicknameCoach, dismissSaintCoach } = useCoachMark()

const recentlyLoginSns = useLocalStorage(STORAGE_RECENTLY_LOGIN_SNS_KEY, null)
const isEditModeOn = ref(false)
const { isMobile } = useDeviceType()
const { fetchMyPostCount } = usePosts()

const { data: myPostCount } = await fetchMyPostCount()
const myPostCountTotal = computed(() => {
  return myPostCount.value ?? 0
})

const newNickname = ref('')

function hanldeInputChange(event: any) {
  if (newNickname.value.length > 25) {
    newNickname.value = newNickname.value.slice(0, 25)
  }
  else {
    newNickname.value = event.target.value
  }
}

function updateNickname() {
  isEditModeOn.value = false
  changeMyNickname(newNickname.value)
}

function openNicknameEdit() {
  newNickname.value = userNickName.value
  isEditModeOn.value = true
}

const { data: integratedProviders } = await fetchMyIntegratedSnsProviders()
</script>

<style scoped>
.nickname {
  position: relative;
  display: inline-block;
}

/* 코치마크 꼬리가 연필(수정) 버튼을 가리키도록 오른쪽으로 살짝 이동 */
.nickname :deep(.coach-mark.align-right) {
  right: -12px;
}

.row-text.account {
  position: relative;
}
</style>
